<app-status-indicator
  [messageStatus]="messageStatus"
  [messageStatuses]="messageStatuses"
  [statusIndicatorButtonId]="_statusIndicatorButtonId"
  [statusIndicatorSpanId]="_statusIndicatorSpanId"
  [showSummary]="!harbourDues || _summary?.harbourDues?.length == 1">
  @if (harbourDues && _summary?.harbourDues?.length > 1) {
    <div class="message-templates row gx-1 gy-2 mt-1">
      @for (harbourDues of sortedHarbourDues; track trackByHarbourDuesId(harbourDues)) {
        <div class="col-12">
          <div class="row">
            <div class="col-6">
              @if (harbourDues.invoiceStart) {
                {{ harbourDues.invoiceStart | date:'dd MMM' }}
              } @else {
                now
              }
              -
              @if (harbourDues.invoiceEnd) {
                {{ harbourDues.invoiceEnd | date:'dd MMM' }}
              } @else {
                now
              }
            </div>
            <div class="col-6">
              <app-task-message-status [messageStatus]="harbourDues.status" [showTooltip]="false"
                                       [label]="harbourDues.rejectionReason"></app-task-message-status>
            </div>
          </div>
        </div>
      }
    </div>
  }
</app-status-indicator>
